export const schemas = {
  ONLINE_COURSE: '线上外教课',
  OFFLINE_COURSE: '常规课',
  AI_INTERACTIVE_CLASS: 'AI互动课',
  REAL_DOUBLE_TEACHER_CLASS: '真人双师课',
  AI_DOUBLE_TEACHER_CLASS: 'AI双师课',
  PRACTICE: '练习',
};

export const classifications = {
  STANDARD_COURSE: '标准课程',
  CUSTOM_COURSE: '定制课程',
  PUBLIC_SCHOOL_COURSE: '同步课程',
  ENRICHED_COURSE: '拓展课程',
};
